// extracted by mini-css-extract-plugin
var _1 = "BuSwJ";
var _2 = "cPIrP";
export { _1 as "base", _2 as "overflow" }
